import { PropertyEquipment } from '@workspace/data-types';

export interface PropertyEquipmentItem {
  label: string;
  icon: string;
  field: PropertyEquipment;
}

export const PROPERTY_EQUIPMENT_ITEMS: PropertyEquipmentItem[] = [
  {
    label: 'Cuisine équipée',
    icon: 'countertops',
    field: PropertyEquipment.KITCHEN_EQUIPMENT,
  },
  { label: 'Meublé', icon: 'chair', field: PropertyEquipment.FURNISHING },
  {
    label: 'Climatisation',
    icon: 'ac_unit',
    field: PropertyEquipment.AIR_CONDITIONING,
  },
  {
    label: 'Ventilation',
    icon: 'air',
    field: PropertyEquipment.VENTILATION,
  },
  {
    label: 'Fibre optique',
    icon: 'cable',
    field: PropertyEquipment.FIBER_OPTIC,
  },
  { label: 'Alarme', icon: 'security', field: PropertyEquipment.ALARM },
  {
    label: 'Domotique',
    icon: 'settings_remote',
    field: PropertyEquipment.HOME_AUTOMATION,
  },
  { label: 'Interphone', icon: 'call', field: PropertyEquipment.INTERCOM },
  { label: 'Digicode', icon: 'dialpad', field: PropertyEquipment.DIGICODE },
  {
    label: 'Portail électrique',
    icon: 'garage',
    field: PropertyEquipment.ELECTRIC_GATE,
  },
  {
    label: 'Caméra de surveillance',
    icon: 'videocam',
    field: PropertyEquipment.SECURITY_CAMERA,
  },
];

export function getPropertyEquipmentInfo(field: PropertyEquipment): { label: string; icon: string } {
  const item = PROPERTY_EQUIPMENT_ITEMS.find((i) => i.field === field);
  return (
    item || {
      label: field,
      icon: 'help_outline',
    }
  );
}
